import actionTypes from './actionTypes';
import { ProductApi } from '../../api/product';

const api = new ProductApi();

export const loadProducts = () => async dispatch => {
    try{
        dispatch({type: actionTypes.LOAD_PRODUCTS_START, payload: {}});
        
        const {data} = await api.getProductsList();

        return dispatch({type: actionTypes.LOAD_PRODUCTS_SUCCESS, payload: {data}});

    }catch(error){
        return dispatch({type: actionTypes.LOAD_PRODUCTS_FAIL, payload: {error}});
    }
};